import { atom, selector } from 'recoil'

const MAX_RELOAD_ERRORS = 9

export const reloadErrorsState = atom({
  key: 'campaignsSendStatusReloadErrorsState',
  default: 0
})

const criticalErrorQueueState = atom({
  key: 'campaignsSendStatusCriticalErrorQueueState',
  default: []
})

export const reloadErrorsIncrementState = selector({
  key: 'campaignsSendStatusReloadErrorsIncrementState',
  set: ({ get, set }, lastErrorTime) => {
    const counter = get(reloadErrorsState)
    set(reloadErrorsState, prev => prev + 1)
    if (counter >= MAX_RELOAD_ERRORS) {
      set(criticalErrorState, lastErrorTime)
    }
  },
  get: ({ get }) => {
    return get(reloadErrorsState)
  }
})

export const criticalErrorState = selector({
  key: 'campaignsSendStatusCriticalErrorState',
  get: ({ get }) => {
    const errors = get(criticalErrorQueueState)
    return errors.length > 5
  },
  set: ({ get, set }, lastErrorTime) => {
    set(criticalErrorQueueState, errors => [
      ...errors.filter(t => lastErrorTime - t < 3000),
      lastErrorTime
    ])
  }
})

export const recoverableErrorState = selector({
  key: 'campaignsSendStatusRecoverableErrorState',
  get: ({ get }) => {
    const errors = get(criticalErrorQueueState)
    return (errors.length >= 1) && (errors.length <= 5)
  }
})
